/* eslint-disable new-cap */
import CryptoJS from 'crypto-js';

export function signKey(clientKey: string, message: string): string {
    const hmac = CryptoJS.HmacSHA256(message, clientKey);

    return CryptoJS.enc.Hex.stringify(hmac);
}
